import { all, call, put, takeEvery } from 'redux-saga/effects'

import {
  CREATE_SROI_REPORT_PAYLOAD,
  createSroiReportPayloadFailure,
  createSroiReportPayloadSuccess,
  DELETE_SROI_REPORT_PAYLOAD,
  deleteSroiReportPayloadFailure,
  deleteSroiReportPayloadSuccess,
  GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT,
  GET_SROI_INPUTS_PRESET,
  GET_SROI_REPORT_PAYLOAD,
  GET_SROI_REPORTS,
  getSocialReturnOnInvestmentReportFailure,
  getSocialReturnOnInvestmentReportSuccess,
  getSroiInputsPresetFailure,
  getSroiInputsPresetSuccess,
  getSroiReportPayloadFailure,
  getSroiReportPayloadSuccess,
  getSroiReportsFailure,
  getSroiReportsSuccess,
  UPDATE_SROI_INPUTS_PRESET,
  UPDATE_SROI_REPORT_PAYLOAD,
  updateSroiInputsPresetFailure,
  updateSroiInputsPresetSuccess,
  updateSroiReportPayloadFailure,
  updateSroiReportPayloadSuccess
} from '../actions/socialReturnOnInvestment'
import {
  createSroiReportPayloadService,
  deleteSroiReportPayloadService,
  getSocialReturnOnInvestmentReportService,
  getSroiInputsPresetService,
  getSroiReportPayloadService,
  getSroiReportsService,
  updateSroiInputsPresetService,
  updateSroiReportPayloadService
} from '../services/socialReturnOnInvestment'

function* socialReturnOnInvestmentWatcher() {
  yield all([
    // PLOP_APPEND_PATTERN_ANCHOR_WATCHER
    takeEvery(GET_SROI_REPORTS, getSroiReportsWorker),
    takeEvery(CREATE_SROI_REPORT_PAYLOAD, createSroiReportPayloadWorker),
    takeEvery(GET_SOCIAL_RETURN_ON_INVESTMENT_REPORT, getSocialReturnOnInvestmentReportWorker),
    takeEvery(GET_SROI_REPORT_PAYLOAD, getSroiReportPayloadWorker),
    takeEvery(UPDATE_SROI_REPORT_PAYLOAD, updateSroiReportPayloadWorker),
    takeEvery(DELETE_SROI_REPORT_PAYLOAD, deleteSroiReportPayloadWorker),
    takeEvery(GET_SROI_INPUTS_PRESET, getSroiInputsPresetWorker),
    takeEvery(UPDATE_SROI_INPUTS_PRESET, updateSroiInputsPresetWorker)
  ])
}

export default socialReturnOnInvestmentWatcher

// PLOP_APPEND_PATTERN_ANCHOR_WORKER
function* getSroiReportsWorker({ params }) {
  try {
    const response = yield call(getSroiReportsService, params)
    yield put(getSroiReportsSuccess(response))
  } catch (error) {
    yield put(getSroiReportsFailure(error))
  }
}

function* getSocialReturnOnInvestmentReportWorker({ params }) {
  try {
    const response = yield call(getSocialReturnOnInvestmentReportService, params)
    yield put(getSocialReturnOnInvestmentReportSuccess(response))
  } catch (error) {
    yield put(getSocialReturnOnInvestmentReportFailure(error))
  }
}

function* getSroiReportPayloadWorker({ params }) {
  try {
    const response = yield call(getSroiReportPayloadService, params)
    yield put(getSroiReportPayloadSuccess(response))
  } catch (error) {
    yield put(getSroiReportPayloadFailure(error))
  }
}

function* createSroiReportPayloadWorker({ data }) {
  try {
    const response = yield call(createSroiReportPayloadService, data)
    yield put(createSroiReportPayloadSuccess(response))
  } catch (error) {
    yield put(createSroiReportPayloadFailure(error))
  }
}

function* updateSroiReportPayloadWorker({ id, data }) {
  try {
    const response = yield call(updateSroiReportPayloadService, id, data)
    yield put(updateSroiReportPayloadSuccess(response))
  } catch (error) {
    yield put(updateSroiReportPayloadFailure(error))
  }
}

function* deleteSroiReportPayloadWorker({ params }) {
  try {
    const response = yield call(deleteSroiReportPayloadService, params)
    yield put(deleteSroiReportPayloadSuccess(response))
  } catch (error) {
    yield put(deleteSroiReportPayloadFailure(error))
  }
}

function* getSroiInputsPresetWorker({ params }) {
  try {
    const response = yield call(getSroiInputsPresetService, params)
    yield put(getSroiInputsPresetSuccess(response))
  } catch (error) {
    yield put(getSroiInputsPresetFailure(error))
  }
}

function* updateSroiInputsPresetWorker({ params, data }) {
  try {
    const response = yield call(updateSroiInputsPresetService, params, data)
    yield put(updateSroiInputsPresetSuccess(response))
  } catch (error) {
    yield put(updateSroiInputsPresetFailure(error))
  }
}
